import * as React from 'react';
import S from './KeyValuesList.styles';
const ValuesList = ({ values }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.List, null, values.map((values) => (React.createElement(React.Fragment, null,
            React.createElement(S.Key, null, values.key),
            React.createElement(S.Value, null, values.value)))))));
};
export default ValuesList;
